$(function () {
    const popup = $('#openingPopup');

    if (!popup.length) {
        return;
    }

    const closeCookie = popup.data('close-cookie');
    const link = popup.find('a');

    popup.on('hidden.bs.modal', function () {
        document.cookie = closeCookie;
    });

    link.on('click', function () {
        document.cookie = link.data('close-cookie');
        popup.modal('hide');
    });

    popup.modal('show');
});